import { makeAutoObservable } from "mobx";

export interface Account {
	id: string;
	name: string;
	leader?: string;
	contactEmail?: string;
	isActive: boolean;
	displaySuffix?: string;
}

export class AccountModel implements Account {
	readonly id: string;
	name: string;
	leader?: string;
	contactEmail?: string;
	isActive: boolean = true;
	displaySuffix?: string;

	constructor(account: Account) {
		makeAutoObservable(this);
		this.id = account.id;
		this.name = account.name;
		this.leader = account.leader;
		this.contactEmail = account.contactEmail;
		this.isActive = account.isActive ?? true;
		this.displaySuffix = account.displaySuffix;
	}
	get canSave() {
		return this.name.trim().length > 0;
	}
	setField<K extends keyof AccountModel>(field: K, value: AccountModel[K]) {
		(this[field] as AccountModel[K]) = value;
	}
}